var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.2954;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#F2F2F2;stroke-width:2.2954;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:none;stroke:#BABABA;stroke-width:2.525;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:none;stroke:#BABABA;stroke-width:2.2954;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#CFCFCF;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:2.525;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.6,101.5c-19.2,0-38.7-0.8-57-5.9c-18.3-5.1-34.3-14.6-49.1-25.8c-9.6-7.3-18.4-13-30.8-12.2 c-12.2,0.6-23.9,5.2-33.3,13c-15.9,13.8-13.5,39.5-7.1,57.6c9.5,27.2,38.5,46.1,63.2,58.4c28.5,14.2,59.7,22.5,91.2,27.2 c27.5,4.2,62.8,7.2,86.7-10.7c21.9-16.5,27.9-54.2,22.5-79.6c-1.3-7.5-5.3-14.2-11.3-19c-15.4-11.2-38.3-3.7-55.6-3.4 C221.7,101.3,215.1,101.5,208.6,101.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.8,34H63.3c-5.7,0-10.3,4.6-10.3,10.3v142c0,5.7,4.6,10.3,10.3,10.3h198.5c5.7,0,10.3-4.6,10.3-10.3v-142 C272.1,38.6,267.5,34,261.8,34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,181.4h196"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,155.7h196"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,130h196"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,104.3h196"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,78.6h196"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,52.9h196"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.6,69.6H86.7c-3.1,0-5.6,2.5-5.6,5.6v101.9c0,3.1,2.5,5.6,5.6,5.6h12.9c3.1,0,5.6-2.5,5.6-5.6V75.3 C105.2,72.1,102.7,69.6,99.6,69.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.9,113.8H133c-3.1,0-5.6,2.5-5.6,5.6v57.7c0,3.1,2.5,5.6,5.6,5.6h12.9c3.1,0,5.6-2.5,5.6-5.6v-57.7 C151.5,116.3,149,113.8,145.9,113.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.2,81.5h-12.9c-3.1,0-5.6,2.5-5.6,5.6v90c0,3.1,2.5,5.6,5.6,5.6h12.9c3.1,0,5.6-2.5,5.6-5.6v-90 C197.8,84,195.3,81.5,192.2,81.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.5,129.5h-12.9c-3.1,0-5.6,2.5-5.6,5.6v41.9c0,3.1,2.5,5.6,5.6,5.6h12.9c3.1,0,5.6-2.5,5.6-5.6v-41.9 C244.1,132.1,241.6,129.5,238.5,129.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.2,120.5l13.5-0.5l37.7,38.7l36-32.8l39.3,12.9l37.9-24.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.5,209.5v9.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.5,214.5h9.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284,79.6v9.9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.1,84.6h9.9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.3,31.8v9.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.4,36.8h9.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.5,166.5c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2S39.2,166.5,40.5,166.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M148.2,10.9c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2S146.9,10.9,148.2,10.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.3,258.5c46.5,0,84.1-2.3,84.1-5.2c0-2.9-37.7-5.2-84.1-5.2c-46.5,0-84.1,2.3-84.1,5.2 C87.1,256.2,124.8,258.5,171.3,258.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M264,63.1c14.7,0,26.6-11.9,26.6-26.6c0-14.7-11.9-26.6-26.6-26.6c-14.7,0-26.6,11.9-26.6,26.6 C237.3,51.1,249.2,63.1,264,63.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M252.4,24.8L275.5,48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275.5,24.8L252.4,48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDashboard);
export default __webpack_public_path__ + "static/media/no-dashboard.91c7c36e2d7f43726d6266f22e9c2243.svg";
export { ForwardRef as ReactComponent };